module.exports = __webpack_public_path__ + "static/media/header_login.b4efd56e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_login.jpg
// module id = 1081
// module chunks = 0